export const uiSchemaCuentasContactosForm = {
  type: "VerticalLayout",
  elements: [
    {
      type: "VerticalLayout",
      elements: [
        {
          type: "Control",
          scope: "#/properties/descripcion",
        },
      ],
    },
  ],
};